import axios from "../../../common/config/axios";
import * as type from "./types";

export const getReferralSettings = (data) => (dispatch, getState) => {
    data.country_id = getState().currentUser.data.country_id;
    axios
        .get("referral_settings/list", {params: data})
        .then((res) => {
            dispatch({
                type: type.REFERRAL_SETTINGS_LIST,
                payload: res,
            });
        })
        .catch((err) => {
            // console.log("Referral Settings Error", err);
            // dispatch({
            //     type: type.REFERRAL_SETTINGS_LIST,
            //     payload: [],
            // });
        });
};

export const editReferralSettings = (id) => (dispatch) => {
    axios
        .get("referral_settings/edit", {
            params: {
                id: id,
            },
        })
        .then((res) => {
            dispatch({
                type: type.REFERRAL_SETTINGS_EDIT,
                payload: res.data,
            });
        })
        .catch((err) => {
            // console.log("Edit Referral Settings Error" + err);
            // dispatch({
            //     type: type.REFERRAL_SETTINGS_EDIT,
            //     payload: err.response,
            // });
        });
};

export const updateReferralSettings = (data) => (dispatch, getState) => {
    data.country_id = getState().currentUser.data.country_id;
    axios
        .post("referral_settings/update", data)
        .then((res) => {
            dispatch({
                type: type.REFERRAL_SETTINGS_UPDATE,
                payload: res.data,
            });
        })
        .catch((err) => {
            // console.log("Update Referral Settings Error", err);
        });
};